import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";
const {
  GET_MY_ORDERS_API,
  GET_ORDER_DETAIL_API,
  GET_SALES_ORDER_HISTORY_API,
  GET_DISTRIBUTOR_SALES_ORDER_IDS,
  DELETE_ORDERS_API,
  REFRESH_ORDERS,
  DOWNLOAD_RAW_ORDER_API,
  GET_LAST_ORDERED_API,
} = END_POINT;

export const getMyOrdersAPI = async () => {
  const response = await apiGet(GET_MY_ORDERS_API);
  console.log("My-Orders-Api-response", response);
  return response;
};

export const getOrderDetailAPI = async ({ id, type }) => {
  const response = await apiPost(`${GET_ORDER_DETAIL_API}${id}`, { type });
  console.log("Order-Detail-Api-response", response);
  return response;
};

export const getSalesOrderHistory = async (payload) => {
  console.log(payload);
  const response = await apiPost(`${GET_SALES_ORDER_HISTORY_API}`, payload);
  console.log("Order-Sales-History-Api-response", response);
  return response;
};

export const getDistributorSalesOrderIds = async (distributor) => {
  const response = await apiPost(`${GET_DISTRIBUTOR_SALES_ORDER_IDS}`, { distributor });
  console.log("getDistributorSalesOrderIds-Api-response", response);
  return response;
};

export const deleteOrdersAPI = async (payload) => {
  const response = await apiPost(`${DELETE_ORDERS_API}`, payload);
  console.log("deleteOrdersAPI-Api-response", response);
  return response;
};

export const refreshOrdersAPI = async (id, type) => {
  console.log("refreshOrdersAPI-id", id, "type", type);
  const response = await apiPost(`${REFRESH_ORDERS}/${id}`, { type });
  console.log("refreshOrdersAPI-Api-response", response);
  return response;
};

export const downloadRawOrderAPI = async (id, type) => {
  const response = await apiPost(`${DOWNLOAD_RAW_ORDER_API}${id}`, { type });
  console.log("downloadRawOrderAPI-Api-response", response);
  return response;
};

export const getLastOrderedByPartsAPI = async (mfrPartNumbers) => {
  const response = await apiPost(GET_LAST_ORDERED_API, {
    mfr_part_numbers: mfrPartNumbers,
  });
  return response;
};


